// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import WebSocket from '~/common/websocket';
import { COMMON_SET_SOCKET_CONNECTION } from './constants';
// import {
//   COMMON_UPDATE_RECENTLY_REASSIGNED_USERS,
//   COMMON_UPDATE_NEW_USERS,
//   COMMON_UPDATE_USERS,
// } from '~/features/common/redux/constants';
// import { getChannelCount, getUserChannelCount } from '~/features/common/redux/actions';

export const setSocketConnection = id => dispatch => {
  const channel = 'chat_menu:' + id;
  const socket = new WebSocket({ channel });

  socket.connect().then(() => {
    const channel = socket.getChannel();

    dispatch({
      type: COMMON_SET_SOCKET_CONNECTION,
      data: { socket, channel },
    });

    // channel.on('refresh', payload => {
    //   const removedUserId = payload.channel_id;
    //   let recentlyReassignedChannels = [...getState().common.recentlyReassignedUsersChannels];
    //   let recentlyReassignedUsers = [...getState().common.recentlyReassignedUsers];
    //   let newChannels = [...getState().common.newUsersChannels];
    //   let newUsers = [...getState().common.newUsers];
    //   let users = [...getState().common.filteredUserList];
    //   let channels = [...getState().common.channels];

    //   recentlyReassignedChannels = removeChannelIdFromChannels(
    //     recentlyReassignedChannels,
    //     removedUserId,
    //   );
    //   recentlyReassignedUsers = removeChannelIdFromChannels(recentlyReassignedUsers, removedUserId);

    //   newChannels = removeChannelIdFromChannels(newChannels, removedUserId);
    //   newUsers = removeChannelIdFromChannels(newUsers, removedUserId);

    //   users = removeChannelIdFromChannels(users, removedUserId);
    //   channels = removeChannelIdFromChannels(channels, removedUserId);

    //   dispatch(
    //     updateGetRecentlyReassignedUsers(recentlyReassignedChannels, recentlyReassignedUsers),
    //   );
    //   dispatch(updateNewUsers(newChannels, newUsers));
    //   dispatch(updateUsers(users, channels));
    //   dispatch(getChannelCount(getState().common.filterParams));
    //   dispatch(getUserChannelCount(getState().common.filterParams));
    // });
  });
};

// const removeChannelIdFromChannels = (channels, userId) => {
//   channels = channels.filter(ch => {
//     return ch.cid !== userId;
//   });

//   return channels;
// };

// const updateGetRecentlyReassignedUsers = (recentlyReassignedChannels, recentlyReassignedUsers) => {
//   return {
//     type: COMMON_UPDATE_RECENTLY_REASSIGNED_USERS,
//     payload: { recentlyReassignedChannels, recentlyReassignedUsers },
//   };
// };

// const updateNewUsers = (newUsersChannels, newUsers) => {
//   return {
//     type: COMMON_UPDATE_NEW_USERS,
//     payload: { newUsersChannels, newUsers },
//   };
// };

// const updateUsers = (userChannels, channels) => {
//   return {
//     type: COMMON_UPDATE_USERS,
//     payload: {
//       userChannels,
//       channels,
//     },
//   };
// };

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SET_SOCKET_CONNECTION:
      return {
        ...state,
        socket: action.data.socket,
        channel: action.data.channel,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/setSocketConnection.js